const isLocal = window.location.hostname === 'localhost' || 
                window.location.hostname === '127.0.0.1' || 
                window.location.hostname.startsWith('192.168.') || 
                window.location.hostname.startsWith('10.');

const API_BASE_URL = isLocal
  ? `http://${window.location.hostname}:5000`
  : 'https://olivedrab-buffalo-405773.hostingersite.com';

export const RECAPTCHA_SITE_KEY = '6LeRjfMtAAAAAEbGT2U3b_vyw15l3lCYQ1XRFY2f';

export default API_BASE_URL;

